/**
 * Bundle / "complete your pair".
 *
 * The add-on cards use the theme's own quick-add: "Choose options" opens the
 * size modal, single-variant products add straight away. Each add-on is a
 * normal add to cart, so this element only has to fill the list and, when the
 * merchant turns the chooser on, drive the modal.
 *
 * The earlier checkbox flow lived here: it collected ticked add-ons and pushed
 * them in on the product form's submit. It was dropped because the card had no
 * way to pick a size, so the cart always received the first available variant.
 *
 * If JS fails, nothing breaks: the product form still adds the main product.
 */
if (!customElements.get('bundle-setup')) {
  class BundleSetup extends HTMLElement {
    connectedCallback() {
      this.list = this.querySelector('[data-list]');

      // The inline list is the merchant's complementary picks (Search &
      // Discovery), fetched through the recommendations API.
      this.loadComplementary();

      // Modal wiring, only present when the chooser is enabled.
      this.modal = this.querySelector('[data-modal]');
      this.querySelectorAll('[data-open-modal]').forEach((b) =>
        b.addEventListener('click', () => this.openModal())
      );
      this.querySelectorAll('[data-close-modal]').forEach((b) =>
        b.addEventListener('click', () => this.closeModal())
      );
      this.querySelectorAll('[data-tab]').forEach((t) =>
        t.addEventListener('click', () => this.switchTab(t.dataset.tab))
      );
    }

    /**
     * Kept because the block's inline fetch calls it after injecting cards.
     * The quick-add buttons wire themselves when their custom element upgrades,
     * so there is nothing left to do here — but the hook must stay callable.
     */
    wireAddons() {}

    async loadComplementary() {
      if (!this.list || this.list.dataset.filled) return;

      const url = this.dataset.recommendUrl;
      const productId = this.dataset.productId;
      if (!url || !productId) return;

      try {
        const res = await fetch(`${url}&product_id=${productId}`);
        if (!res.ok) return;
        const html = await res.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const cards = doc.querySelector('[data-complementary-cards]');
        if (!cards || !cards.children.length) return;
        this.list.innerHTML = cards.innerHTML;
        this.list.dataset.filled = '1';
      } catch (e) {
        // No inline suggestions if the fetch fails; the page is unaffected.
      }
    }

    openModal() {
      if (!this.modal) return;
      if (typeof this.modal.showModal === 'function') this.modal.showModal();
      else this.modal.setAttribute('open', '');
    }

    closeModal() {
      if (!this.modal) return;
      if (typeof this.modal.close === 'function') this.modal.close();
      else this.modal.removeAttribute('open');
    }

    switchTab(id) {
      this.querySelectorAll('[data-tab]').forEach((t) =>
        t.setAttribute('aria-selected', String(t.dataset.tab === id))
      );
      this.querySelectorAll('[data-panel]').forEach((p) => {
        p.hidden = p.dataset.panel !== id;
      });
    }
  }

  customElements.define('bundle-setup', BundleSetup);
}
